"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageClassification = exports.MessageSendType = void 0;
/**
 * 消息队列分级，目前分为串行队列和并行队列两种类型：
 */
var MessageSendType;
(function (MessageSendType) {
    /**
     * 串行队列，队列内必须一个个按顺序发，上一个发送完成才可以下一个发送；
     * 数据之间有关联性和依赖性，比如 Command.USER_CHANGES
     */
    MessageSendType["SERIAL"] = "SERIAL";
    /**
     * 并行队列，队列中的数据可并行发送
     * 数据之间没有依赖关系， 比如 CURSOR_MESSAGE
     */
    MessageSendType["PARALLEL"] = "PARALLEL";
})(MessageSendType = exports.MessageSendType || (exports.MessageSendType = {}));
var MessageClassification = /** @class */ (function () {
    function MessageClassification(messageSendTypePairs) {
        if (messageSendTypePairs === void 0) { messageSendTypePairs = []; }
        this.messageClassfyMap = new Map(messageSendTypePairs);
    }
    MessageClassification.prototype.setMessageSendType = function (command, messageSendType) {
        this.messageClassfyMap.set(command, messageSendType);
    };
    MessageClassification.prototype.getMessageSendType = function (command) {
        var _a;
        /**
         * 默认未自定义设置过消息发送级别的，统一为同步消息，需要等待 onSendAccept 确认
         */
        return (_a = this.messageClassfyMap.get(command)) !== null && _a !== void 0 ? _a : MessageSendType.SERIAL;
    };
    return MessageClassification;
}());
exports.MessageClassification = MessageClassification;
